// extracted by mini-css-extract-plugin
module.exports = {"card":"business-card-module--card--2pY8o","buttoncontainer":"business-card-module--buttoncontainer--2HaQK"};